import { SET_ANSWERNEW } from "../actions/types";

const INITIAL_STATE = {};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_ANSWERNEW:
      //console.log("Respuesta Reducer AnswerNew", action);
      return { ...action.payload.Result };
    default:
      return state;
  }
};
